import $ from 'jquery';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';

const classes = {
	overlayPage: 'OverlayPage',
	stickyEnabled: 'is-sticky',
	stick: 'is-stick',
};
const selectors = {
	parent: `.${classes.overlayPage}`,
	stickyHeader: `.${classes.overlayPage}-backButton.${classes.stickyEnabled}`,
};

const $window = $(window);
const stickyLarge = 961;

function setupStickyHeader($parent) {
	const $stickyHeader = $parent.find(selectors.stickyHeader);

	if ($stickyHeader.length) {
		const handleScroll = () => {
			let scrollStick = -5;
			if ($(window).outerWidth() >= stickyLarge) {
				scrollStick = -20;
			}

			const shouldStick = Math.round($parent.get(0).getBoundingClientRect().top) <= scrollStick;
			if (shouldStick) {
				if (!$stickyHeader.hasClass(classes.stick)) {
					$stickyHeader.addClass(classes.stick);
				}
			} else {
				if ($stickyHeader.hasClass(classes.stick)) {
					$stickyHeader.removeClass(classes.stick);
				}
			}
		};
		$window.on('scroll', throttle(handleScroll, 40)).on('scroll', debounce(handleScroll, 60));
	}
}

/**
 * Initializes the overlayPage functionalities.
 * @param {jQuery} $parent parent element
 */
function initOverlayPage($parent) {
	setupStickyHeader($parent);
}

export default function init() {
	$(selectors.parent).each((_, parent) => {
		const $parent = $(parent);
		initOverlayPage($parent);
	});
}
